/**
 * 短信模板编码
 */
export enum SmsTemplateCode {
  // 登录验证码
  LOGIN = 'SMS_465352143',
  // 注册验证码
  REGISTER = 'SMS_465362161',
  // 重置密码验证码
  RESET_PASSWORD = 'SMS_465397294',
  // 改绑手机号验证码
  BIND_PHONE = 'SMS_465362163',
  // 绑定 MFA
  BIND_MFA = 'SMS_483940089',
  // 解除 MFA
  RELEASE_MFA = 'SMS_484075190',
  // 供需发布验证码
  SUPPLY_DEMAND = 'SMS_465387244',
  // 模拟出价验证码
  MOCK_BID = 'SMS_465327213',
  // 场次报名验证码
  TRADE_SESSION_APPLY = 'SMS_465407261',
  // 前往出价时的身份验证
  TRADE_SESSION_BID = 'SMS_498225554'
}
